<template>
    <CriterionDateDurationInput v-bind="propsWithAttrs" unit="days" />
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaInteger } from '@evidentid/json-schema/interfaces/JsonSchema';

    import AbstractCriterionInput
        from '@/modules/decisioning-criteria/components/CriterionInputComponents/AbstractCriterionInput';
    import CriterionDateDurationInput
        from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionDateDurationInput.vue';

    @Component({
        components: { CriterionDateDurationInput },
    })
    export default class CriterionDaysInput extends AbstractCriterionInput<JsonFormBase<JsonSchemaInteger>, number> {}
</script>
